// extracted by mini-css-extract-plugin
module.exports = {"input":"search_input__1oiBT","label":"search_label__3tgEk"};